// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__L3KFQ","resendInfoText":"OnGoingPaymentBox_resendInfoText__1a3Qh"};